<!--
  - La vista NORMAL muestra un listado de adjuntos, con sus opciones de descarga / edición / borrado a la derecha de la linea. Se usa para los listados de adjuntos de algún contenido.

  - La vista ALTERNATIVA muestra un recuadro para incluir una imagen. Una vez subida, se superponen las opciones de editar / borrar. Se usa para incluir una imagen para un colegiado (p.e.)
-->

<ng-template #noAttachments>
  <div class="no-attachments" [class.view-mode-2]="viewMode===2">
    <web-file-input (fileChange)="onFile($event)" [maxSize]="maxSizeAttachment" [acceptedFiles]="acceptedFiles"
      class="image-upload-no-file">

      <!-- Vista normal -->
      <button *ngIf="!viewMode || viewMode===1" type="button" mat-flat-button color="accent">
        <div class="new-attachment-button-content">
          <mat-icon>attachment</mat-icon>
          <span *ngIf="!titleAttachment">{{'attachment.newAttachment'|translate}}</span>
          <span *ngIf="titleAttachment">{{titleAttachment}}</span>
        </div>
      </button>

      <!-- Vista alternativa -->
      <button *ngIf="viewMode===2" type="button" mat-button color="accent" class="add-attachment-button">
        <mat-icon>edit</mat-icon>
      </button>

    </web-file-input>
  </div>
</ng-template>

<!-- Vista normal -->
<div *ngIf="!viewMode || viewMode===1" class="view-mode-1 attach-content">
  <div class="attachment">
    <ng-container *ngIf="attachment && (attachment.hash || attachment.pending); else noAttachments">
      <div [ngClass]="{delete: attachment.delete, pending: !attachment.hash || attachment.pending}">
        <div matLine class="item attachment-item">
          <div class="thumbnail thumbnail-row truncate">
            <img loading="lazy" *ngIf="type === 2" src="{{attachment.url}}" class="img-attachment" #img
              (error)="img.src='../../../../assets/img/base/document.svg'; img.style.border='0'">
            <img loading="lazy" *ngIf="type === 1" src="../../../../assets/img/base/pdf_document.svg"
              class="icon-document">
            <div class="name truncate">
              <div>{{titleAttachment}}</div>
              <div class="pending" *ngIf="!attachment.hash || attachment.pending">{{'attachment.pending'|translate}}
              </div>
            </div>
          </div>
          <div class="options attachment-options">
            <button *ngIf="attachment.hash" mat-icon-button (click)="download();$event.stopPropagation();">
              <mat-icon>file_download</mat-icon>
            </button>
            <web-file-input *ngIf="!disabled" (fileChange)="onFile($event)" [maxSize]="maxSizeAttachment"
              [acceptedFiles]="acceptedFiles" class="image-upload-no-file">
              <button type="button" mat-icon-button>
                <mat-icon>edit</mat-icon>
              </button>
            </web-file-input>
            <button *ngIf="!disabled" mat-icon-button (click)="del();$event.stopPropagation();">
              <mat-icon *ngIf="!attachment.delete">delete</mat-icon>
              <mat-icon *ngIf="attachment.delete">delete_forever</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Vista alternativa -->
<div *ngIf="viewMode===2" class="view-mode-2 attach-content">
  <div class="attachment">
    <ng-container *ngIf="attachment && (attachment.hash || attachment.pending); else noAttachments">

      <div class="thumbnail" [class.disabled]="disabled"
        [ngClass]="{delete: attachment.delete, pending: !attachment.hash || attachment.pending}">

        <div class="image">
          <div *ngIf="type === 2" [lazyBg]="backgroundImg" class="img-attachment"></div>
          <div class="red-layer"></div>
        </div>

        <div class="options attachment-options-centered" *ngIf="!disabled">
          <web-file-input (fileChange)="onFile($event)" [maxSize]="maxSizeAttachment" [acceptedFiles]="acceptedFiles">
            <button type="button" mat-icon-button>
              <mat-icon>edit</mat-icon>
            </button>
          </web-file-input>
          <button mat-icon-button (click)="del();$event.stopPropagation();">
            <mat-icon *ngIf="!attachment.delete">delete</mat-icon>
            <mat-icon *ngIf="attachment.delete">delete_forever</mat-icon>
          </button>
        </div>

      </div>

    </ng-container>
  </div>
</div>
